import { useState } from "react";
import { Form, Toast, ToastContainer } from "react-bootstrap";
import { supabase } from "../supabaseClient";
import DashboardHeader from "../components/DashboardHeader";
import { ShieldAlert, AlertCircle, Save, X, CheckCircle } from "lucide-react";

export default function ChangePasswordPage({ memberData }) {
  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setError(null);
    if (!newPassword || newPassword.length < 8) {
      setError("Parola nouă trebuie să aibă cel puțin 8 caractere.");
      return;
    }
    if (newPassword !== newPassword2) {
      setError("Parolele noi introduse nu coincid.");
      return;
    }
    setLoading(true);

    const { error: updateError } = await supabase.auth.updateUser({ password: newPassword });
    setLoading(false);
    
    if (updateError) {
      setError("A apărut o eroare la schimbarea parolei. (" + updateError.message + ")");
      return;
    }
    
    setShowSuccess(true);
    setNewPassword("");
    setNewPassword2("");
  };

  const labelStyle = { color: "#cbd5e1", fontSize: "0.85rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "1px", marginBottom: "8px", display: "block" };
  const inputStyle = {
    backgroundColor: "#0f172a", border: "1px solid rgba(255, 255, 255, 0.1)", color: "#f8fafc", borderRadius: "12px", padding: "14px 18px", width: "100%", outline: "none", transition: "all 0.2s ease", fontSize: "1rem"
  };

  return (
    <div className="dashboard-wrapper" style={{ overflowX: "hidden", minHeight: "100vh", backgroundColor: "#0b1120", paddingBottom: "60px" }}>
      <DashboardHeader user={memberData} />
      
      <style>{`
        .premium-input:focus {
          border-color: #fbbf24 !important;
          box-shadow: 0 0 0 2px rgba(251, 191, 36, 0.2) !important;
        }
        .premium-card {
          background-color: #1e293b;
          border-radius: 24px;
          padding: 40px;
          border: 1px solid rgba(255, 255, 255, 0.05);
          box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.3);
        }
        .custom-toast {
          background-color: rgba(16, 185, 129, 0.95) !important; /* Emerald */
          color: white !important;
          border: none !important;
          border-radius: 16px !important;
          backdrop-filter: blur(10px);
        }
      `}</style>

      <div className="container" style={{ maxWidth: "600px", margin: "48px auto" }}>
        <div className="premium-card">
          <div className="mb-5 d-flex align-items-center">
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: 56,
                height: 56,
                borderRadius: "16px",
                background: "rgba(251, 191, 36, 0.1)",
                color: "#fbbf24",
                marginRight: 20,
              }}
            >
              <ShieldAlert size={28} />
            </span>
            <div>
              <h3 style={{ fontWeight: 800, color: "#f8fafc", margin: 0, fontSize: "1.75rem" }}>Schimbă parola</h3>
              <p style={{ marginBottom: 0, color: "#94a3b8", fontSize: "0.95rem", marginTop: "4px" }}>
                Pentru mai multă siguranță, folosește o parolă puternică și unică contului tău PRDP.
              </p>
            </div>
          </div>

          <Form onSubmit={handleChangePassword}>
            <Form.Group className="mb-4">
              <label style={labelStyle}>Parola nouă</label>
              <input
                type="password"
                className="premium-input"
                style={inputStyle}
                value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
                placeholder="Introdu parola nouă (minim 8 caractere)"
                autoComplete="new-password"
                minLength={8}
                required
              />
            </Form.Group>
            
            <Form.Group className="mb-4">
              <label style={labelStyle}>Confirmare parolă nouă</label>
              <input
                type="password"
                className="premium-input"
                style={inputStyle}
                value={newPassword2}
                onChange={e => setNewPassword2(e.target.value)}
                placeholder="Reintrodu parola nouă"
                autoComplete="new-password"
                minLength={8}
                required
              />
            </Form.Group>

            {error && (
              <div style={{ backgroundColor: "rgba(239, 68, 68, 0.1)", color: "#ef4444", padding: "16px", borderRadius: "12px", marginBottom: "24px", display: "flex", alignItems: "center", gap: "10px", fontWeight: "500" }}>
                <AlertCircle size={20} /> {error}
              </div>
            )}

            <div className="d-flex gap-3 mt-4">
              <button 
                type="submit" 
                disabled={loading}
                style={{
                  backgroundColor: "#fbbf24", color: "#0f172a", border: "none", borderRadius: "12px", padding: "14px 28px", fontWeight: 700, fontSize: "1rem", display: "flex", alignItems: "center", gap: "8px", cursor: loading ? "not-allowed" : "pointer", transition: "all 0.2s ease", opacity: loading ? 0.7 : 1, width: "100%", justifyContent: "center"
                }}
                onMouseEnter={(e) => { if (!loading) e.currentTarget.style.backgroundColor = "#f59e0b"; }}
                onMouseLeave={(e) => { if (!loading) e.currentTarget.style.backgroundColor = "#fbbf24"; }}
              >
                <Save size={20} /> {loading ? "Se schimbă..." : "Schimbă parola"}
              </button>
              
              <button 
                type="button" 
                onClick={() => window.location.href = "/setari"}
                style={{
                  backgroundColor: "transparent", color: "#cbd5e1", border: "1px solid rgba(255,255,255,0.1)", borderRadius: "12px", padding: "14px 28px", fontWeight: 600, fontSize: "1rem", display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", transition: "all 0.2s ease"
                }}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.05)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}
              >
                <X size={20} /> Anulează
              </button>
            </div>
          </Form>
        </div>

        <ToastContainer position="top-end" className="p-4" style={{ zIndex: 9999 }}>
          <Toast className="custom-toast" onClose={() => setShowSuccess(false)} show={showSuccess} delay={5000} autohide>
            <Toast.Body className="d-flex align-items-center gap-2" style={{ fontSize: "1rem", fontWeight: 500, padding: "16px" }}>
              <CheckCircle size={22} /> Parola a fost schimbată cu succes!
            </Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
    </div>
  );
}
